var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{staticClass:"add-button btn-primary",style:(_vm.resolveColor)},[_c('div',{staticClass:"d-flex align-items-center"},[_c('icon-setting-manage',{staticClass:"mr-2"}),_c('span',[_vm._v(_vm._s(_vm.btnLabel))])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }